// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './validate/validate'
import router from './router'
import store from './store/index.js'
// import VueMdl from 'vue-mdl'
import AtComponents from 'at-ui'
import 'at-ui-style' // Import CSS

Vue.use(AtComponents)
// Vue.use(VueMdl)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<router-view></router-view>'
})



// WEBPACK FOOTER //
// ./src/main.js